import { IPersonBadge } from "../../../../../../common/types";
import { getHoursMinsFromDate } from "../../../../../../common/utils/dateUtils";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import InsertPhotoOutlinedIcon from "@mui/icons-material/InsertPhotoOutlined";
import { useTranslation } from "react-i18next";
import EventHelper from "common/network/helpers/event/EventHelper";

type Props = {
  badge: IPersonBadge;
  setSelectedBadge: (badge: IPersonBadge) => void;
  ordersCount: number;
};

export const InfoIconsBar = ({ badge, setSelectedBadge, ordersCount }: Props) => {
  const { t } = useTranslation("common");

  const photoUploadedTranslation = t("tooltips.companyBadgeTable.photoUploaded");
  const scannedBadgesTranslation = t("tooltips.companyBadgeTable.firstScanTime", {
    scanTime: getHoursMinsFromDate(badge.firstScannedDate || "")
  });
  const printedBadgesTranslation = t("tooltips.companyBadgeTable.lastPrintTime", {
    printTime: getHoursMinsFromDate(badge.lastPrintedDate || "")
  });
  const numberOfOrdersTranslation = t("tooltips.companyBadgeTable.numberOfOrders", { ordersCount });

  const isPhotoRequired = EventHelper.eventEdition?.isPhotoRequiredForAccess;

  const ordersModalHandle = () => {
    setSelectedBadge(badge);
  };

  return (
    <Stack direction={"row"} data-testid="badge-status-bar-icons">
      {isPhotoRequired && (
        <Tooltip title={photoUploadedTranslation} placement="top" arrow>
          <IconButton data-testid="imageBtn" color="primary" disabled={!badge.photoKey}>
            <InsertPhotoOutlinedIcon />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title={scannedBadgesTranslation} placement="top" arrow>
        <IconButton data-testid="scannerBtn" color="primary" disabled={!badge.firstScannedDate}>
          <DocumentScannerIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={printedBadgesTranslation} placement="top" arrow>
        <IconButton data-testid="printerBtn" color="primary" disabled={!badge.lastPrintedDate}>
          <LocalPrintshopIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={numberOfOrdersTranslation} placement="top" arrow>
        <IconButton onClick={ordersModalHandle} data-testid="ordersBtn" color="primary" disabled={ordersCount === 0}>
          <ReceiptLongIcon />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};
